/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { gql } from 'graphql-tag';
/* AppSync */
import appsyncclient from '../../api/AppSync';
/* GraphQL */

import makeData from '../mock/makeData';
const initialState = [];
/*******************************************************************************
 * main
 ******************************************************************************/
export function teamInviteReducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case 'teamMangement/invite/InviteAdded': {
      return [payload, ...state];
    }

    case 'teamMangement/invite/InviteLoaded': {
      return payload;
    }

    default:
      return state;
  };
};

// get team invite Thunk function
export function fetchGetTeamInvite(search = '') {
  return async dispatch => {
    try {
      // const response = await appsyncclient.query({
      //   query: gql(queryGetInvite),
      //   variables: { user_id: ,  search}
      // });
      console.log(`search invite member: ${search}`)
      const response = {
        data: {
          getInvite: makeData(10, 5)
        }
      }

      dispatch({ type: 'teamMangement/invite/InviteLoaded', payload: response.data.getInvite });
    } catch (error) {
      console.error('fetchGetTeamInvite error: ', error);
    };
  }
};

// add team invite Thunk function
export function fetchAddTeamInvite(params) {
  return async dispatch => {
    try {
      // const response = await appsyncclient.mutate({
      //   mutation: gql(queryAddInvite),
      //   variables: { user_id:  , ..params}
      // });
      console.log(params)
      dispatch({ type: 'teamMangement/invite/InviteAdded', payload: params });
    } catch (error) {
      console.error('fetchAddTeamInvite error: ', error);
    };
  }
};